import $ from 'jquery';
import BasketService from '../service/BasketService';
import YandexEcommerce from '../utilities/YandexEcommerce';

const updateProductQuantity = (domObject, quantityDelta) => {
    const mainObjectDom = domObject.parents('.catalog-item-to-basket');
    const currentCount = mainObjectDom.attr('data-quantity');

    let quantity = (+currentCount) + (+quantityDelta);
    if (quantity === 0) {
        quantity = 1;
    }

    mainObjectDom.attr('data-quantity', quantity);
    mainObjectDom.find('.catalog-item-to-basket__quantity').text(quantity);
};

let addInProgress = false;
$('body').on('click', '.js-catalog-item-to-basket__button', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (addInProgress) {
        return;
    }
    addInProgress = true;

    const productId = $(this).parents('.catalog-item-to-basket').attr('data-catalog-item-id');
    const productQuantity = $(this).parents('.catalog-item-to-basket').attr('data-quantity');

    $(this).parents('.catalog-item-to-basket').addClass('catalog-item-to-basket--in-basket');
    BasketService.add(productId, productQuantity).then(({ count }) => {
        BasketService.updateHeaderCounter(count);
        addInProgress = false;
    });
});

$('body').on('click', '.js-catalog-item-to-basket__minus', function (e) {
    e.preventDefault();
    e.stopPropagation();
    updateProductQuantity($(this), -1);
});

$('body').on('click', '.js-catalog-item-to-basket__plus', function (e) {
    e.preventDefault();
    e.stopPropagation();
    updateProductQuantity($(this), 1);
});

$('body').on('click', '.js-catalog-item-to-basket__link', function (e) {
    e.preventDefault();
    e.stopPropagation();
    window.location = '/basket';
});
